import React, { useEffect, useRef } from 'react';

import { loadRecaptcha } from '../services/Recaptcha';

const RecaptchaV2 = ({ siteKey, onToken }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        let active = true;
        if (!siteKey || !containerRef.current) { return undefined; }
        loadRecaptcha().then((grecaptcha) => {
            if (!active || !containerRef.current) { return; }
            containerRef.current.replaceChildren();
            grecaptcha.render(containerRef.current, {
                sitekey: siteKey,
                callback: onToken,
                'expired-callback': () => onToken(''),
                'error-callback': () => onToken(''),
            });
        }).catch(() => onToken(''));
        return () => { active = false; };
    }, [siteKey, onToken]);

    return React.createElement('div', {
        ref: containerRef,
        'aria-label': 'CAPTCHA challenge',
        style: { marginTop: 12, marginBottom: 12, minHeight: 78 },
    });
};

export default RecaptchaV2;

